/**
 * @file 认证信息修改
 * @author
 */
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import PropTypes from 'prop-types';

import {Carousel} from 'antd';

import StepsMenu from '../../components/StepsMenu/index.tsx';
import Step1 from '../markMsg/step1';
import Step2 from './step2';
import Step3 from '../mark/step3';
import {updateVerifyMsg, fetchMsgType, cleanVerifyMsg} from '../../actions/verifyMsgAction';
import {fetchUserInfo} from '../../actions/attestAction';

import imgPhoneEdit from '../mark/imgs/phone-edit.png';
import imgPhoneEditNormal from '../mark/imgs/phone-edit-normal.png';
import imgVerifyNormal from './imgs/verfify-edit-normal.png';
import imgVerify from './imgs/verfify-edit.png';
import {bCat_2055_request, getQueryString, handleLogin} from '../../util';

import './verifyMsg.less';

export const VerifyMsg = (props) => {
    const {verifyMsgData, updateVerifyMsg, fetchPhoneType, cleanVerifyMsg} = props;

    // const getQueryString = (name) => {
    //     const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    //     const search = location.search.split('?')[1] || '';
    //     const r = search.match(reg) || [];
    //     return r[2];
    // };
    useEffect(() => {
        handleLogin(props.fetchUserInfo);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            cleanVerifyMsg();
        };
    }, [location.pathname]);
    useEffect(() => {
        const searchUrl = getQueryString('phones');
        let phoneListTemp = [];
        /* eslint-disable */
        if (searchUrl) {
            try {
                phoneListTemp = JSON.parse(decodeURIComponent(searchUrl));
                searchFn({phone: phoneListTemp[0].phone, phoneName: phoneListTemp[0].name});
                // setPhoneList(phoneListTemp);
                updateVerifyMsg({
                    // curStep: 2,
                    // phone: phoneListTemp[0].phone,
                    // phoneName: phoneListTemp[0].name,
                    phoneList: phoneListTemp
                });
            } catch (e) {
                console.log('e');
                console.log(e);
            }
        }
    }, [location.search]);

    const stepList = [
        {
            title: '1.填写号码信息',
            imgNormal: imgPhoneEditNormal,
            img: imgPhoneEdit
        },
        {
            title: '2.查询认证方式',
            imgNormal: imgVerifyNormal,
            img: imgVerify
        }
    ];
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const searchFn = (data) => {
        // recordProxy('verifyMsg', 'click', 'search');
        let json = {
            phone: data.phone.replace(/\s+/g, '')
        };
        const fetchMark = (params) => fetchPhoneType({
            ...json,
            ...params
        }).then(res => {
            if (res && res.code === 200 && res.data.auth_type !== 0) {
                updateVerifyMsg({
                    phone: data.phone,
                    phoneName: data.phoneName,
                    titleName: res.data.companyName,
                    curStep: 2,
                    authType: res.data.auth_type,
                    distributor: res.data.distributor
                    // distributor:
                    // markType: data.data.list[0].tagId
                });
                window.scrollTo(0, 0);
            } else if (res && res.code === 200 && res.data.auth_type === 0) {
                updateVerifyMsg({
                    phone: data.phone,
                    phoneErr: <span>
                        该号码未认证，无需进行修改,
                        <a target="_blank" href="//haoma.baidu.com/attest">了解认证</a>
                    </span>,
                });
            } else {
                updateVerifyMsg({
                    phone: data.phone,
                    phoneErr: res && res.message ? res.message : '请求错误',
                });
            }
        });
        bCat_2055_request(fetchMark);
    }
    /* eslint-enable */

    return (
        <div className={'verify-msg-page'}>
            <div className="banner">
                <Carousel className="custom-carousel-class" autoplay>
                    <div className="carousel-item">
                        <div className="item-info-wrapper">
                            <p className="title">认证信息修改</p>
                            <p className="title-tip">已认证企业或政府信息修改</p>
                        </div>
                        <div className="bottom-line"></div>
                    </div>
                </Carousel>
            </div>

            <div className="steps-menu">
                <StepsMenu data={stepList} curStep={verifyMsgData.curStep} />
            </div>
            <div className="mark-msg-page-content">
                {verifyMsgData.curStep === 1
                    && <Step1
                        {...props}
                        inputPlaceholder="请输入任意认证的号码"
                        data={verifyMsgData}
                        updateData={updateVerifyMsg}
                        pageType="verifyMsg"
                        searchFn={searchFn}
                    />
                }
                {verifyMsgData.curStep === 2 && <Step2 {...props} />}
                {verifyMsgData.curStep === 3
                    && <Step3
                        {...props}
                        tip="官方客服将在7天内向您致电，请保持手机畅通"
                        btn1Url="/home"
                        btn1Text="前往首页"
                        btn2Text="查看申述记录"
                        btn2Url="/user_center/my_mark"
                    />
                }
            </div>
        </div>
    );
};

VerifyMsg.propTypes = {
    history: PropTypes.object,
    fetchAppealSearch: PropTypes.func,
    updateVerifyMsg: PropTypes.func,
    verifyMsgData: PropTypes.object,
    fetchSendCode: PropTypes.func,
    location: PropTypes.object,
    fetchPhoneType: PropTypes.func,
    cleanVerifyMsg: PropTypes.func,
    fetchUserInfo: PropTypes.func
};

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo,
        verifyMsgData: state.verifyMsgReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateVerifyMsg: obj => updateVerifyMsg(dispatch, obj),
        fetchPhoneType: obj => fetchMsgType(dispatch, obj),
        cleanVerifyMsg: obj => cleanVerifyMsg(dispatch, obj),
        fetchUserInfo: obj => fetchUserInfo(dispatch, obj)

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VerifyMsg));
